import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { Modal, ModalProps } from "Components/ReactstrapSlim";
import { EnterpriseAccountPlan, EnterpriseDemoRequestMode, InterestReason } from "Services/API/API";
import { trackLeadCaptureForm } from "Utils/gaTrackers";

import classes from "./styles.module.scss"
import ModalBodyForm, { type ContactUsForm, type ModalBodyFormRef } from "./ModalBodyForm";
import ModalBodySuccess from "./ModalBodySuccess";
import { FormType } from "./FormType";

export { type ContactUsForm, ContactUsSchema } from "./ModalBodyForm";
export { FormType } from "./FormType";

export interface ContactUsModalProps extends ModalProps {
   email?: string,
   selectedPlan?: EnterpriseAccountPlan,
   formType: FormType,
   toggle: () => void;
   mode: EnterpriseDemoRequestMode;
   formName?: string;
   defaultValues?: Partial<Omit<ContactUsForm, "email" | "formType">>
   interestReason?: string;
}

const ContactUsModal: React.FC<ContactUsModalProps> = function (props) {
   const { selectedPlan, email, formType, toggle, mode, className, size, formName, defaultValues, interestReason, ...rest } = props;

   const [showSuccessScreen, setShowSuccessScreen] = useState<InterestReason>();

   useEffect(() => {
      trackLeadCaptureForm(mode, "open");
   }, [])

   const modalBodyFormRef = useRef<ModalBodyFormRef>();
   
   return (
      <Modal
         className={classNames(classes.modal, className)}
         contentClassName={classes.modalContent}
         size="lg" {...rest}
         toggle={toggle}
         onOpened={() => modalBodyFormRef.current?.setFocus("fullName")}
         trapFocus
      >
         {
            showSuccessScreen === undefined
               ? <ModalBodyForm ref={x => { modalBodyFormRef.current = x ?? undefined; }} setShowSuccessScreen={setShowSuccessScreen} {...props} />
               : <ModalBodySuccess interestReason={showSuccessScreen} toggle={toggle} />
         }
      </Modal>
   );
}

export default ContactUsModal;
